module.exports = __webpack_public_path__ + "static/media/up-arrow-svgrepo-com (8).508a037f.svg";